/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PspRequestResponseDto
 */
export interface PspRequestResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PspRequestResponseDto
     */
    payload: string;
    /**
     * 
     * @type {PspRequestResponseDtoTypeEnum}
     * @memberof PspRequestResponseDto
     */
    type: PspRequestResponseDtoTypeEnum;
}


/**
 * @export
 */
export const PspRequestResponseDtoTypeEnum = {
    ADYEN_CREATE_PAYMENT_SESSION_REQUEST: 'ADYEN_CREATE_PAYMENT_SESSION_REQUEST',
    ADYEN_CREATE_PAYMENT_SESSION_RESPONSE: 'ADYEN_CREATE_PAYMENT_SESSION_RESPONSE',
    ADYEN_CREATE_PAYMENT_REQUEST: 'ADYEN_CREATE_PAYMENT_REQUEST',
    ADYEN_CREATE_PAYMENT_RESPONSE: 'ADYEN_CREATE_PAYMENT_RESPONSE',
    ADYEN_CREATE_TERMINAL_PAYMENT_REQUEST: 'ADYEN_CREATE_TERMINAL_PAYMENT_REQUEST',
    ADYEN_CREATE_TERMINAL_PAYMENT_RESPONSE: 'ADYEN_CREATE_TERMINAL_PAYMENT_RESPONSE',
    ADYEN_CANCEL_TERMINAL_PAYMENT_REQUEST: 'ADYEN_CANCEL_TERMINAL_PAYMENT_REQUEST',
    ADYEN_CANCEL_TERMINAL_PAYMENT_RESPONSE: 'ADYEN_CANCEL_TERMINAL_PAYMENT_RESPONSE',
    ADYEN_CAPTURE_PAYMENT_REQUEST: 'ADYEN_CAPTURE_PAYMENT_REQUEST',
    ADYEN_CAPTURE_PAYMENT_RESPONSE: 'ADYEN_CAPTURE_PAYMENT_RESPONSE',
    ADYEN_REFUND_PAYMENT_REQUEST: 'ADYEN_REFUND_PAYMENT_REQUEST',
    ADYEN_REFUND_PAYMENT_RESPONSE: 'ADYEN_REFUND_PAYMENT_RESPONSE',
    SOFTPAY_CREATE_PAYMENT_REQUEST: 'SOFTPAY_CREATE_PAYMENT_REQUEST',
    SOFTPAY_CREATE_PAYMENT_RESPONSE: 'SOFTPAY_CREATE_PAYMENT_RESPONSE',
    SOFTPAY_CREATE_REFUND_REQUEST: 'SOFTPAY_CREATE_REFUND_REQUEST',
    SOFTPAY_CREATE_REFUND_RESPONSE: 'SOFTPAY_CREATE_REFUND_RESPONSE',
    NETS_CREATE_PAYMENT_REQUEST: 'NETS_CREATE_PAYMENT_REQUEST',
    NETS_CREATE_PAYMENT_RESPONSE: 'NETS_CREATE_PAYMENT_RESPONSE',
    NETS_CREATE_REFUND_REQUEST: 'NETS_CREATE_REFUND_REQUEST',
    NETS_CREATE_REFUND_RESPONSE: 'NETS_CREATE_REFUND_RESPONSE'
} as const;
export type PspRequestResponseDtoTypeEnum = typeof PspRequestResponseDtoTypeEnum[keyof typeof PspRequestResponseDtoTypeEnum];


/**
 * Check if a given object implements the PspRequestResponseDto interface.
 */
export function instanceOfPspRequestResponseDto(value: object): value is PspRequestResponseDto {
    if (!('payload' in value) || value['payload'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PspRequestResponseDtoFromJSON(json: any): PspRequestResponseDto {
    return PspRequestResponseDtoFromJSONTyped(json, false);
}

export function PspRequestResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PspRequestResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payload': json['payload'],
        'type': json['type'],
    };
}

export function PspRequestResponseDtoToJSON(json: any): PspRequestResponseDto {
    return PspRequestResponseDtoToJSONTyped(json, false);
}

export function PspRequestResponseDtoToJSONTyped(value?: PspRequestResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payload': value['payload'],
        'type': value['type'],
    };
}

